/**
 * Selettore del mese di fatturazione, condiviso fra "Riepilogo mese" e
 * "Da emettere".
 *
 * Le fatture di un mese si emettono nei primi giorni di quello dopo: aprire
 * sempre sul mese corrente vuol dire mostrare settembre a chi sta fatturando
 * agosto. Fino al giorno di chiusura (SOGLIA) il mese proposto è quindi il
 * precedente, e resta comunque cambiabile.
 */
const MESI = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
const MESI_ESTESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
                     'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
const SOGLIA = 10;

/** Mese su cui si sta effettivamente lavorando oggi. */
export function meseDiLavoro() {
  const d = new Date();
  if (d.getDate() <= SOGLIA) {
    const p = new Date(d.getFullYear(), d.getMonth() - 1, 1);
    return { anno: p.getFullYear(), mese: p.getMonth() + 1, arretrato: true };
  }
  return { anno: d.getFullYear(), mese: d.getMonth() + 1, arretrato: false };
}

/** Ultimo giorno del mese, in formato YYYY-MM-DD (mai toISOString: sfasa il giorno). */
export function fineMese(anno, mese) {
  const d = new Date(anno, mese, 0);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export const nomeMese = (mese) => MESI_ESTESI[mese - 1];

export default function SelettoreMese({ anno, mese, onChange, children }) {
  const adesso = new Date();
  const sposta = (n) => {
    const d = new Date(anno, mese - 1 + n, 1);
    onChange(d.getFullYear(), d.getMonth() + 1);
  };
  const suggerito = meseDiLavoro();
  const eSuggerito = suggerito.anno === anno && suggerito.mese === mese;

  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex">
          <button onClick={() => sposta(-1)} title="Mese precedente"
                  className="px-2 py-1 text-sm border border-gray-300 rounded-l bg-white text-gray-600 hover:bg-gray-50">◀</button>
          <button onClick={() => sposta(1)} title="Mese successivo"
                  className="px-2 py-1 text-sm border border-l-0 border-gray-300 rounded-r bg-white text-gray-600 hover:bg-gray-50">▶</button>
        </div>

        {/* .input impone w-full fuori da @layer e batte le utility di larghezza:
            la misura si dà al contenitore, non alla select. */}
        <div className="w-24 shrink-0">
          <select className="input py-1 text-sm" value={anno}
                  onChange={e => onChange(Number(e.target.value), mese)}>
            {[0, 1, 2, 3, 4].map(i => {
              const a = adesso.getFullYear() - i;
              return <option key={a} value={a}>{a}</option>;
            })}
          </select>
        </div>

        <div className="flex gap-1 flex-wrap">
          {MESI.map((m, i) => (
            <button key={m} onClick={() => onChange(anno, i + 1)}
              className={`btn-sm btn ${mese === i + 1 ? 'bg-brand-600 text-white' : 'bg-white text-gray-600 border border-gray-300 hover:bg-gray-50'}`}>
              {m}
            </button>
          ))}
        </div>

        {!eSuggerito && (
          <button onClick={() => onChange(suggerito.anno, suggerito.mese)}
                  className="btn-sm btn bg-white text-brand-700 border border-brand-300 hover:bg-brand-50"
                  title="Torna al mese che stai fatturando">
            ↩ {MESI[suggerito.mese - 1]} {suggerito.anno}
          </button>
        )}

        {children}
      </div>

      {eSuggerito && suggerito.arretrato && (
        <p className="text-xs text-brand-700">
          Sei nei primi giorni del mese: la competenza proposta è <strong>{nomeMese(mese)} {anno}</strong>,
          il mese che stai fatturando adesso.
        </p>
      )}
    </div>
  );
}
